import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=71e040e6&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style1 from "./NotFound.vue?vue&type=style&index=1&id=71e040e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e040e6",
  null
  
)

export default component.exports